import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';


import { useNavigate } from "react-router-dom";

import { ProjectSearchParams, getProjects, createProject, uploadProjectPhoto, editProject, fetchProjectPhotoBlob, deleteProject, createProjectLocation, getProjectLocations } from "../services/projectListingService.tsx";
// import { LocationSearchParams, getLocations, createLocation, editLocation, deleteLocation } from "../services/locationService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";

// Dummy Data

const projectTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "#164396  ",
  "KON": "gray",
  "SK": "orange"
};

const sources = ["PLN", "BUMN Non-PLN", "Swasta", "Pemerintahan"];
const projectTypes = ["Residential", "Commercial", "Infrastructure", "Industrial"];
const constructionPhases = ["Planning", "Design", "Procurement", "Execution", "Finishing"];
const regions = ["Jamali", "Sulmapana", "Sumkal"];

const ProjectListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddProjectDialog, setOpenAddProjectDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [startDateS, setStartDateS] = useState<string | null>(null);
  const [endDateS, setEndDateS] = useState<string | null>(null);

  const [startDateE, setStartDateE] = useState<string | null>(null);
  const [endDateE, setEndDateE] = useState<string | null>(null);

  const [valueMin, setValueMin] = useState("");
  const [valueMax, setValueMax] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "projectName", label: "Project Name" },
    { value: "source", label: "Source" },
    { value: "projectReferenceId", label: "Kode Project" },
    { value: "region", label: "Region" },
    { value: "projectType", label: "Project Type" },
    { value: "constructionPhase", label: "Project Phase" },
    { value: "valueEstimation", label: "Value Estimation" },
    { value: "projectAddress", label: "Project Address" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    projectName?: string;
    projectAddress?: string;
    projectReferenceId?: string;
    source?: string;
    projectType?: string;
    constructionPhase?: string;
    region?: string;
    city?: string;
    state?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    salesProjectId?: string;
    valueEstimation?: string;
    startDate?: string;
    endDate?: string;
    startDateS?: string;
    endDateS?: string;
    startDateE?: string;
    endDateE?: string;
    valueMin?: string;
    valueMax?: string;
    limit?: number;
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchProjects = async () => {
    setIsLoading(true);
    try {


      const result = await getProjects({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });


      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {

    fetchProjects();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const [projectData, setProjectData] = useState<{
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation: string,
    projectType: string,
    file: File | null;
  }>({
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
  });

  const [errors, setErrors] = useState({
    source: false,
    projectName: false,
    projectAddress: false,
    projectReferenceId: false,
    city: false,
    region: false,
    district: false,
    latitude: false,
    longitude: false,
    constructionPhase: false,
    startDate: false,
    endDate: false,
    salesProjectId: false,
    valueEstimation: false,
    projectType: false,
  });

  const [openEditProjectDialog, setOpenEditProjectDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editProjectData, setEditProjectData] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [originalEditProjectData, setOriginalEditProjectData] = useState<{
    id: string,
    source: string,
    projectName: string,
    projectAddress: string,
    projectReferenceId: string,
    city: string,
    region: string,
    district: string,
    latitude: string,
    longitude: string,
    constructionPhase: string,
    startDate: string,
    endDate: string,
    salesProjectId: string,
    valueEstimation?: string;
    projectType: string,
    file: File | null;
    salesProjectImage: string;
    previewUrl: string;
  }>({
    id: "",
    source: "",
    projectName: "",
    projectAddress: "",
    projectReferenceId: "",
    city: "",
    region: "",
    district: "",
    latitude: "",
    longitude: "",
    constructionPhase: "",
    startDate: "",
    endDate: "",
    salesProjectId: "",
    valueEstimation: "",
    projectType: "",
    file: null,
    salesProjectImage: "",
    previewUrl: "",
  });

  const [editErrors, setEditErrors] = useState({
    source: false,
    projectName: false,
    projectAddress: false,
    projectReferenceId: false,
    city: false,
    region: false,
    district: false,
    latitude: false,
    longitude: false,
    constructionPhase: false,
    startDate: false,
    endDate: false,
    salesProjectId: false,
    projectType: false,
    valueEstimation: false,
  });

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
    const maxSize = 50 * 1024 * 1024; // 50MB

    // Validate file type
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid file type",
        text: "Only PDF and Image files are allowed",
      });
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "Maximum file size is 50MB",
      });
      return;
    }

    setProjectData({ ...projectData, file });
  };

  const handleEditFileUpload = (file: File) => {
    const validTypes = ["application/pdf","image/png", "image/jpeg", "image/jpg"];
    const maxSize = 50 * 1024 * 1024; // 50MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .pdf, .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 50MB",
      });
      return;
    }

    setEditProjectData({ ...editProjectData, file , salesProjectImage: file.name});
  };

  const handleFileUploadEdit = async (file: File) => {
    const validTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
    const maxSize = 50 * 1024 * 1024; // 50MB

    // Validate file type
    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid file type",
        text: "Only PDF and Image files are allowed",
      });
      return;
    }

    // Validate file size
    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "Maximum file size is 50MB",
      });
      return;
    }

    setEditProjectData({ ...editProjectData, file });
  };

  const generateDisplayFilename = (projectName: string): string => {
    if (!projectName) return "Project_unknown_project.pdf";

    // Bersihkan nama project untuk nama file
    const cleanProjectName = projectName
      .replace(/\s+/g, "_")
      .replace(/[^a-zA-Z0-9_-]/g, "")
      .substring(0, 50);

    return `Project_${cleanProjectName}.pdf`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProjectData({ ...projectData, [name]: value });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditProjectData({ ...editProjectData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      source: !projectData.source,
      projectName: !projectData.projectName,
      projectAddress: !projectData.projectAddress,
      // projectReferenceId: !projectData.projectReferenceId,
      city: !projectData.city,
      region: !projectData.region,
      district: !projectData.district,
      latitude: !projectData.latitude,
      longitude: !projectData.longitude,
      constructionPhase: !projectData.constructionPhase,
      startDate: !projectData.startDate,
      endDate: !projectData.endDate,
      // salesProjectId: !projectData.salesProjectId,
      projectType: !projectData.projectType,
      valueEstimation: !projectData.valueEstimation,
    };

    console.log(newErrors)

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      source: !editProjectData.source,
      projectName: !editProjectData.projectName,
      projectAddress: !editProjectData.projectAddress,
      // projectReferenceId: !editProjectData.projectReferenceId,
      city: !editProjectData.city,
      region: !editProjectData.region,
      district: !editProjectData.district,
      latitude: !editProjectData.latitude,
      longitude: !editProjectData.longitude,
      constructionPhase: !editProjectData.constructionPhase,
      startDate: !editProjectData.startDate,
      endDate: !editProjectData.endDate,
      // salesProjectId: !editProjectData.salesProjectId,
      projectType: !editProjectData.projectType,
      valueEstimation: !editProjectData.valueEstimation,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|projectEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "projectEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "projectEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddProject = async () => {
    if (validateForm()) {
      try {
        // Step 1: Create project
        await console.log(projectData)
        const newProject = await createProject(projectData); // get response with `id` or `code`


        // Step 2: Upload photo if available
        if (projectData.file) {
          await uploadProjectPhoto(newProject.id, projectData.file);
        }

        Swal.fire({
          icon: "success",
          title: "Project berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
        setOpenAddProjectDialog(false);
        fetchProjects();
        setProjectData({
          source: "",
          projectName: "",
          projectAddress: "",
          projectReferenceId: "",
          city: "",
          region: "",
          district: "",
          latitude: "",
          longitude: "",
          constructionPhase: "",
          startDate: "",
          endDate: "",
          salesProjectId: "",
          valueEstimation: "",
          projectType: "",
          file: null,
        });

        await fetchProjects();

      } catch (error: any) {
        let title = await "Gagal membuat project";
        await errorResponse(title, error);
      }

    } else {
      showPopupMandatoryError();
    }
  };

  const handleSubmitEditProject = async () => {
    if (validateEditForm()) {
      try {
        const updatedProject = await editProject(editProjectData);




        if (editProjectData.file && editProjectData.file.name !== originalEditProjectData.salesProjectImage) {
          await uploadProjectPhoto(editProjectData.id, editProjectData.file);
        }

        Swal.fire({
          icon: "success",
          title: "Project berhasil diperbarui",
          confirmButtonColor: "#0F62FE",
        });

        await fetchProjects();

        await setOpenEditProjectDialog(false);
        await setIsEditing(false);

        // Optional: refresh item list
        await setCurrentPage(1); // agar fetch ulang
      } catch (error) {
        let title = await "Gagal mengubah project";
        await errorResponse(title, error);
      }

    } else {
      showPopupMandatoryError();
    }
  };

  const handleOpenEditProject = async (project) => {
    const salesProjectImage = project.salesProjectImage;

    let previewUrl;
    if (salesProjectImage && typeof salesProjectImage === "string" && !salesProjectImage.endsWith('.pdf')) {
      const fetch = await fetchProjectPhotoBlob(salesProjectImage);
      previewUrl = URL.createObjectURL(fetch);
    }
    if (salesProjectImage && typeof salesProjectImage === "string" && salesProjectImage.endsWith('.pdf')) {
      previewUrl = await fetchProjectPhotoBlob(salesProjectImage);
    }

    await setEditProjectData({
      ...project,
      file: null,
      salesProjectImage: project.salesProjectImage,
      previewUrl, // ← simpan di state
    });
    await console.log(project, editProjectData);
    await setOriginalEditProjectData(project); // Simpan nilai asli untuk tombol cancel
    await setIsEditing(false); // Kunci form sampai tombol edit diklik
    await setOpenEditProjectDialog(true);
  };

  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedProject = await deleteProject(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Project berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchProjects(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditProject = () => {
    setEditProjectData(originalEditProjectData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditProjectDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
    const name = filters[index].field;
    if (name === "startDate") { setStartDateS(null); setEndDateS(null); }
    if (name === "endDate") { setStartDateE(null); setEndDateE(null); }
    if (name === "valueEstimation") { setValueMin(""); setValueMax(""); }
    console.log(filters, startDateS, endDateS)
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ProjectSearchParams`
      const searchParams: ProjectSearchParams = {};

      if (startDateS && endDateS) {
        if (startDateS === endDateS) {
          searchParams.startDate = await startDateS;
        } else {
          searchParams.startDateS = await startDateS;
          searchParams.endDateS = await endDateS;
        }
      }

      if (startDateS && !endDateS) {
        searchParams.startDate = await startDateS;
      }

      if (startDateE && endDateE) {
        if (startDateE === endDateE) {
          searchParams.endDate = await startDateE;
        } else {
          searchParams.startDateE = await startDateE;
          searchParams.endDateE = await endDateE;
        }
      }

      if (startDateE && !endDateE) {
        searchParams.endDate = await startDateE;
      }

      if (valueMin && valueMax) {
        if (valueMin === valueMax) {
          searchParams.valueEstimation = await valueMin;
        } else {
          searchParams.valueMin = await valueMin;
          searchParams.valueMax = await valueMax;
        }
      }

      if (valueMin && !valueMax) {
        searchParams.valueEstimation = await valueMin;
      }

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getProjects(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
    setStartDateS(null);
    setEndDateS(null);
    setStartDateE(null);
    setEndDateE(null);
    setValueMin("");
    setValueMax("");
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getProjects({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Project");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Projects_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export project data',
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allProjects = await getProjects({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allProjects.data.map(project => ({
      'Project Name': project.projectName,
      'Source': project.projectEmail,
      'Kode Project': project.projectAddress,
      'Longitude': project.longitude,
      'Latitude': project.latitude,
      'Region': project.region,
      'City': project.city,
      'District': project.district,
      'Project Type': project.projectType,
      'Project Phase': project.constructionPhase,
      'Start Date': project.startDate,
      'End Date': project.endDate,
      'Value Estimation': project.valueEstimation,
    }));
  };

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header & Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Project List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select value={rowsPerPage} onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }} size="small">
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
                autoFocus
                className="searchInput"
              />
            )}

            {/* Menampilkan Error */}
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>

          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.projectid));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            {/* Filter Button */}
            <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => setOpenFilterDialog(true)}
            >
              Filters
            </Button>
            <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
              Export
            </Button>
            <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => setOpenAddProjectDialog(true)}>
              Add New Project
            </Button>
          </Box>
        </Box>


        {/* Delete Button & Subtitle */}

        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All Projects
          </Typography>
        </Box>


        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                {/* Checkbox header */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                {/* Header dengan sorting */}
                <TableCell className="tableCell" onClick={() => handleSort("projectName")} style={{ cursor: "pointer" }}>
                  <strong>Project Name</strong>
                  {sortConfig.orderBy === "projectName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectEmail")} style={{ cursor: "pointer" }}>
                  <strong>Source</strong>
                  {sortConfig.orderBy === "projectEmail" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectAddress")} style={{ cursor: "pointer" }}>
                  <strong>Kode Project</strong>
                  {sortConfig.orderBy === "projectAddress" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("managerName")} style={{ cursor: "pointer" }}>
                  <strong>Region</strong>
                  {sortConfig.orderBy === "managerName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("projectType")} style={{ cursor: "pointer" }}>
                  <strong>Project Type</strong>
                  {sortConfig.orderBy === "projectType" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("constructionPhase")} style={{ cursor: "pointer" }}>
                  <strong>Project Phase</strong>
                  {sortConfig.orderBy === "constructionPhase" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("startDate")} style={{ cursor: "pointer" }}>
                  <strong>Start Date</strong>
                  {sortConfig.orderBy === "startDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("endDate")} style={{ cursor: "pointer" }}>
                  <strong>End Date</strong>
                  {sortConfig.orderBy === "endDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("valueEstimation")} style={{ cursor: "pointer" }}>
                  <strong>Value (Est)</strong>
                  {sortConfig.orderBy === "valueEstimation" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell">
                </TableCell> {/* Kolom untuk aksi */}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedRows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  {/* Checkbox */}
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  {/* Data */}
                  <TableCell className="tableCell" title={row.projectName}><strong>{row.projectName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.source}>{row.source}</TableCell>
                  <TableCell className="tableCell" title={row.projectReferenceId}>{row.projectReferenceId}</TableCell>
                  <TableCell className="tableCell" title={row.region}>{row.region}</TableCell>
                  <TableCell className="tableCell" title={row.projectType}>{row.projectType}</TableCell>
                  <TableCell className="tableCell" title={row.constructionPhase}>{row.constructionPhase}</TableCell>
                  <TableCell className="tableCell" title={row.startDate}>{row.startDate}</TableCell>
                  <TableCell className="tableCell" title={row.endDate}>{row.endDate}</TableCell>
                  <TableCell className="tableCell" title={row.valueEstimation}>{row.valueEstimation}</TableCell>
                  {/* Status Badge */}
                  {/* <TableCell className="tableCell" title={row.projectType}>
                    <Box className="statusBadge" style={{ backgroundColor: projectTypeColors[row.projectType] ? projectTypeColors[row.projectType] : "grey" }}>
                      {row.projectType}
                    </Box>
                  </TableCell> */}
                  {/* Ikon More Options */}
                  {/* Ikon More Options */}
                  <TableCell className="tableCell">
                    <IconButton onClick={() => handleOpenEditProject(row)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


        {/* Pagination */}
        <Box
          className="paginationContainer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* Info jumlah data */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          {/* Komponen Pagination */}
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Rows?</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Add New Project */}
        <Dialog open={openAddProjectDialog} onClose={() => setOpenAddProjectDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Add New Project</Typography>
              <IconButton onClick={() => setOpenAddProjectDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Project Name" name="projectName"
                    placeholder="Enter project name" value={projectData.projectName}
                    onChange={handleInputChange} error={errors.projectName}
                    helperText={errors.projectName ? "Mandatory Field" : ""}
                  />
                  <TextField
                    fullWidth label="Input Project Code" name="projectReferenceId"
                    placeholder="Enter project address" value={projectData.projectReferenceId}
                    onChange={handleInputChange} error={errors.projectReferenceId}
                    helperText={errors.projectReferenceId ? "Mandatory Field" : ""}
                  />
                </Box>

                <TextField
                  fullWidth label="Input Value Estimation" name="valueEstimation"
                  placeholder="Enter project address" value={projectData.valueEstimation}
                  onChange={handleInputChange} error={errors.valueEstimation}
                  helperText={errors.valueEstimation ? "Mandatory Field" : ""}
                />

                <TextField
                  fullWidth label="Input Project Address" name="projectAddress"
                  placeholder="Enter project address" value={projectData.projectAddress}
                  onChange={handleInputChange} error={errors.projectAddress}
                  helperText={errors.projectAddress ? "Mandatory Field" : ""}
                />

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={projectData.latitude}
                    longitude={projectData.longitude}
                    onSelect={({ lat, lng }) => {
                      // if (isEditing) {
                      setProjectData({ ...projectData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                      // else {
                      //   setProjectData({ ...projectData, latitude: lat.toString(), longitude: lng.toString() });
                      // }
                    }}
                  />

                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Latitude" name="latitude"
                    placeholder="Enter latitude" value={projectData.latitude}
                    onChange={handleInputChange} error={errors.latitude}
                    helperText={errors.latitude ? "Mandatory Field" : ""}
                  />
                  <TextField
                    fullWidth label="Input Longitude" name="longitude"
                    placeholder="Enter longitude" value={projectData.longitude}
                    onChange={handleInputChange} error={errors.longitude}
                    helperText={errors.longitude ? "Mandatory Field" : ""}
                  />
                </Box>

                {/* File Upload */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    gap: 3,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    padding: 4,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                      handleFileUpload(e.dataTransfer.files[0]);
                    }
                  }}
                >
                  {projectData.file ? (
                    <>
                      <PictureAsPdfIcon fontSize="large" color="primary" />
                      <Typography variant="body2" mt={1}>
                        {projectData.file?.name || "Uploaded PDF"}
                      </Typography>
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          backgroundColor: "rgba(255,255,255,0.7)",
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.9)",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setProjectData((prev) => ({
                            ...prev,
                            file: null,
                          }));
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <PictureAsPdfIcon fontSize="large" color="action" />
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        mt={1}
                      >
                        Drag & drop or click to upload proposal (PDF)
                      </Typography>
                    </>
                  )}
                  <input
                    hidden
                    accept=".pdf,application/pdf"
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        handleFileUpload(e.target.files[0]);
                      }
                    }}
                  />
                  <Typography variant="caption" mt={1}>
                    Max size: 2MB (.pdf only)
                  </Typography>
                </Box>

                <TextField
                  select
                  fullWidth label="Input Region" name="region"
                  placeholder="Enter region" value={projectData.region}
                  onChange={handleInputChange} error={errors.region}
                  helperText={errors.region ? "Mandatory Field" : ""}
                >
                  <MenuItem value="">Select Region</MenuItem>
                  {regions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input City" name="city"
                    placeholder="Enter city" value={projectData.city}
                    onChange={handleInputChange} error={errors.city}
                    helperText={errors.city ? "Mandatory Field" : ""}
                  />
                  <TextField
                    fullWidth label="Input District" name="district"
                    placeholder="Enter district" value={projectData.district}
                    onChange={handleInputChange} error={errors.district}
                    helperText={errors.district ? "Mandatory Field" : ""}
                  />
                </Box>
              </Box>



              {/* Right Side (Dropdowns & Inputs) */}
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  select
                  fullWidth label="Project Type" name="projectType"
                  placeholder="Select project type" value={projectData.projectType}
                  onChange={handleInputChange} error={errors.projectType}
                  helperText={errors.projectType ? "Mandatory Field" : ""}
                >
                  <MenuItem value="" disabled>Select Project Type</MenuItem>
                  {projectTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Source" name="source"
                  placeholder="Select source" value={projectData.source}
                  onChange={handleInputChange} error={errors.source}
                  helperText={errors.source ? "Mandatory Field" : ""}
                >
                  <MenuItem value="" disabled>Select Source</MenuItem>
                  {sources.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  select
                  fullWidth label="Construction Phase" name="constructionPhase"
                  placeholder="Select construction phase" value={projectData.constructionPhase}
                  onChange={handleInputChange} error={errors.constructionPhase}
                  helperText={errors.constructionPhase ? "Mandatory Field" : ""}
                >
                  <MenuItem value="" disabled>Select Construction Phase</MenuItem>
                  {constructionPhases.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Start Date"
                    format="YYYY-MM-DD"
                    value={
                      projectData.startDate
                        ? dayjs(projectData.startDate)
                        : null
                    }
                    onChange={(newValue) =>
                      handleInputChange({
                        target: {
                          name: "startDate",
                          value: newValue
                            ? dayjs(newValue).format("YYYY-MM-DD")
                            : "",
                        },
                      })
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "startDate",
                        error: !projectData.startDate,
                        helperText: !projectData.startDate
                          ? "Mandatory Field"
                          : "",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select End Date"
                    format="YYYY-MM-DD"
                    value={
                      projectData.endDate
                        ? dayjs(projectData.endDate)
                        : null
                    }
                    onChange={(newValue) =>
                      handleInputChange({
                        target: {
                          name: "endDate",
                          value: newValue
                            ? dayjs(newValue).format("YYYY-MM-DD")
                            : "",
                        },
                      })
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "endDate",
                        error: !projectData.endDate,
                        helperText: !projectData.endDate
                          ? "Mandatory Field"
                          : "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddProjectDialog(false)}>CANCEL</Button>
            <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddProject}>SAVE</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Edit Project */}
        <Dialog open={openEditProjectDialog} onClose={() => setOpenEditProjectDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Edit Project</Typography>
              <IconButton onClick={() => setOpenEditProjectDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
              {/* Left Side (Inputs & Map) */}
              <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Project Name" name="projectName"
                    placeholder="Enter project name" value={editProjectData.projectName}
                    onChange={handleEditInputChange} error={editErrors.projectName}
                    helperText={editErrors.projectName ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth label="Input Project Code" name="projectReferenceId"
                    placeholder="Enter project code" value={editProjectData.projectReferenceId}
                    onChange={handleEditInputChange} error={editErrors.projectReferenceId}
                    helperText={editErrors.projectReferenceId ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                </Box>

                <TextField
                  fullWidth label="Input Value Estimation" name="valueEstimation"
                  placeholder="Enter value estimation" value={editProjectData.valueEstimation}
                  onChange={handleEditInputChange} error={editErrors.valueEstimation}
                  helperText={editErrors.valueEstimation ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                />

                <TextField
                  fullWidth label="Input Project Address" name="projectAddress"
                  placeholder="Enter project address" value={editProjectData.projectAddress}
                  onChange={handleEditInputChange} error={editErrors.projectAddress}
                  helperText={editErrors.projectAddress ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                />

                {/* Map Placeholder */}
                <Box sx={{ width: "100%", height: "auto", bgcolor: "inherit", display: "flex", alignItems: "center", justifyContent: "center", my: 2 }}>
                  <MapPinLocation
                    latitude={editProjectData.latitude}
                    longitude={editProjectData.longitude}
                    disabled={!isEditing}
                    onSelect={({ lat, lng }) => {
                      if (isEditing) {
                        setEditProjectData({
                          ...editProjectData,
                          latitude: lat.toString(),
                          longitude: lng.toString(),
                        });
                      }
                    }}
                  />
                </Box>

                {/* Latitude & Longitude */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input Latitude" name="latitude"
                    placeholder="Enter latitude" value={editProjectData.latitude}
                    onChange={handleEditInputChange} error={editErrors.latitude}
                    helperText={editErrors.latitude ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth label="Input Longitude" name="longitude"
                    placeholder="Enter longitude" value={editProjectData.longitude}
                    onChange={handleEditInputChange} error={editErrors.longitude}
                    helperText={editErrors.longitude ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                </Box>

                {/* File Upload */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    gap: 3,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border:
                      editProjectData.previewUrl ||
                        editProjectData.file
                        ? "2px solid #aaa"
                        : "2px dashed #aaa",
                    padding: 4,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: isEditing ? "pointer" : "default",
                    position: "relative",
                    opacity: isEditing ? 1 : 0.7,
                  }}
                  disabled={!isEditing}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    if (isEditing) {
                      e.preventDefault();
                      const file = e.dataTransfer.files[0];
                      handleEditFileUpload(file);
                    }
                  }}
                  onClick={() => {
                    if (isEditing) {
                      editFileInputRef.current?.click();
                    }
                  }}
                >
                  {editProjectData.previewUrl ||
                    editProjectData.file ? editProjectData.salesProjectImage.endsWith('.pdf') ? (
                      <>
                        <PictureAsPdfIcon
                          fontSize="large"
                          color={isEditing ? "primary" : "disabled"}
                        />
                        <Typography variant="body2" mt={1}>
                          {generateDisplayFilename(editProjectData.projectName)}
                        </Typography>

                        {/* {isEditing && ( */}
                        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (editProjectData.file) {
                                window.open(
                                  URL.createObjectURL(editProjectData.file),
                                  "_blank"
                                );
                              }
                              if (!editProjectData.file && editProjectData.previewUrl) {
                                window.open(
                                  URL.createObjectURL(editProjectData.previewUrl),
                                  "_blank"
                                );
                              }
                            }}
                          >
                            DOWNLOAD
                          </Button>

                        </Box>
                        {/* )} */}
                      </>
                    ) : (
                    editProjectData.file ? (
                      <img
                        src={URL.createObjectURL(editProjectData.file)}
                        alt="Preview"
                        style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                      />
                    ) : editProjectData.previewUrl ? (
                      <img
                        src={editProjectData.previewUrl}
                        alt="Existing"
                        style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                      />
                    ) : (
                      <>
                        <PhotoCamera fontSize="large" />
                        <Typography variant="body2" color="textSecondary" mt={1}>
                          Drag & drop or click to upload image
                        </Typography>
                      </>
                    )
                  ) : (
                    <>
                      <PictureAsPdfIcon
                        fontSize="large"
                        color={isEditing ? "action" : "disabled"}
                      />
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        mt={1}
                      >
                        {isEditing
                          ? "Drag & drop or click to upload (PDF)"
                          : "No file uploaded"}
                      </Typography>
                    </>
                  )}

                  {isEditing && (
                    <input
                      hidden
                      accept=".pdf,application/pdf"
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handleFileUploadEdit(e.target.files[0]);
                        }
                      }}
                    />
                  )}
                </Box>

                <TextField
                  select
                  fullWidth label="Input Region" name="region"
                  placeholder="Enter region" value={editProjectData.region}
                  onChange={handleEditInputChange} error={editErrors.region}
                  helperText={editErrors.region ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="">Select Region</MenuItem>
                  {regions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth label="Input City" name="city"
                    placeholder="Enter city" value={editProjectData.city}
                    onChange={handleEditInputChange} error={editErrors.city}
                    helperText={editErrors.city ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                  <TextField
                    fullWidth label="Input District" name="district"
                    placeholder="Enter district" value={editProjectData.district}
                    onChange={handleEditInputChange} error={editErrors.district}
                    helperText={editErrors.district ? "Mandatory Field" : ""}
                    disabled={!isEditing}
                  />
                </Box>
              </Box>

              {/* Right Side */}
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  fullWidth label="Sales Project ID" name="salesProjectId"
                  placeholder="Enter project code" value={editProjectData.salesProjectId}
                  onChange={handleEditInputChange} error={editErrors.salesProjectId}
                  helperText={editErrors.salesProjectId ? "Mandatory Field" : ""}
                  disabled
                />
                <TextField
                  select
                  fullWidth label="Project Type" name="projectType"
                  placeholder="Select project type" value={editProjectData.projectType}
                  onChange={handleEditInputChange} error={editErrors.projectType}
                  helperText={editErrors.projectType ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>Select Project Type</MenuItem>
                  {projectTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  fullWidth label="Source" name="source"
                  placeholder="Select source" value={editProjectData.source}
                  onChange={handleEditInputChange} error={editErrors.source}
                  helperText={editErrors.source ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>Select Source</MenuItem>
                  {sources.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  fullWidth label="Construction Phase" name="constructionPhase"
                  placeholder="Select construction phase" value={editProjectData.constructionPhase}
                  onChange={handleEditInputChange} error={editErrors.constructionPhase}
                  helperText={editErrors.constructionPhase ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="" disabled>Select Construction Phase</MenuItem>
                  {constructionPhases.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Start Date"
                    disabled={!isEditing}
                    format="YYYY-MM-DD"
                    value={editProjectData.startDate ? dayjs(editProjectData.startDate) : null}
                    onChange={(newValue) => {
                      if (isEditing) {
                        handleEditInputChange({
                          target: {
                            name: "startDate",
                            value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                          },
                        });
                      }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "startDate",
                        error: !editProjectData.startDate,
                        helperText: !editProjectData.startDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select End Date"
                    disabled={!isEditing}
                    format="YYYY-MM-DD"
                    value={editProjectData.endDate ? dayjs(editProjectData.endDate) : null}
                    onChange={(newValue) => {
                      if (isEditing) {
                        handleEditInputChange({
                          target: {
                            name: "endDate",
                            value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                          },
                        });
                      }
                    }}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "endDate",
                        error: !editProjectData.endDate,
                        helperText: !editProjectData.endDate ? "Mandatory Field" : "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          </DialogContent>


          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            {!isEditing ? (
              // Tombol Edit Muncul di Awal
              <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
                EDIT
              </Button>
            ) : (
              // Tombol Save & Cancel Muncul Saat Edit
              <>
                <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                  CANCEL
                </Button>
                <Button onClick={handleSubmitEditProject} variant="contained" color="success" sx={{ width: 120 }}>
                  SAVE
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>




        {/* ======================= Filter Dialog ============================= */}
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
          <DialogTitle>Advanced Search</DialogTitle>
          <DialogContent>
            {filters.map((filter, index) => {
              const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
              const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

              return (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    select
                    value={filter.field}
                    onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {availableOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {filter.field === "projectType" ? (
                    <TextField
                      select
                      label="Project Type"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {projectTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "source" ? (
                    <TextField
                      select
                      label="Source"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {sources.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "region" ? (
                    <TextField
                      select
                      label="Region"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {regions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "constructionPhase" ? (
                    <TextField
                      select
                      label="Project Phase"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {constructionPhases.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "startDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateS ? dayjs(startDateS) : null}
                          onChange={(newValue) =>
                            setStartDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateS ? dayjs(endDateS) : null}
                          onChange={(newValue) =>
                            setEndDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "endDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateE ? dayjs(startDateE) : null}
                          onChange={(newValue) =>
                            setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateE ? dayjs(endDateE) : null}
                          onChange={(newValue) =>
                            setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "valueEstimation" ? (
                    <>
                      <TextField
                        label="Value Min"
                        variant="outlined"
                        size="small"
                        value={valueMin}
                        onChange={(e) =>
                          setValueMin(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                      <TextField
                        label="Value Max"
                        variant="outlined"
                        size="small"
                        value={valueMax}
                        onChange={(e) =>
                          setValueMax(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    </>

                  ) : (
                    <TextField
                      label="Value"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  )}

                  {index > 0 && (
                    <IconButton onClick={() => handleRemoveFilter(index)}>
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              );
            })}

            {filters.length < availableFilters.length && (
              <Button startIcon={<Add />} onClick={handleAddFilter}>
                Add Filter
              </Button>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters}>Reset Filter</Button>
            <Button onClick={handleCloseFilter}>Cancel</Button>
            <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
              {isLoading ? "Loading..." : "Apply"}
            </Button>
          </DialogActions>
        </Dialog>

      </Box>
  );
};

export default ProjectListPage;
